import useSWR from 'hooks/useSWR';
import { useSWRResource } from 'util/resource/useSWRResource';
import { userAPIUrls } from './usersApi';
import { PostableSourcesDTO } from 'types/content';

export const usePostableSources = () => {
  const swrResult = useSWR<PostableSourcesDTO>(userAPIUrls.postableSources(), undefined, {
    // Setting a shorter cache duration, because getting a new feed could be caused
    // by someone else's action and it is hard to cover all the self-caused cases anyway
    dedupingInterval: 20 * 1000,
  });

  return useSWRResource(swrResult);
};
